import getSelectedFolderViewState from '../selectors/getSelectedFolderViewState';
import TodoListItemViewState from '../store/schema/TodoListItemViewState';
import { IPoint } from 'office-ui-fabric-react/lib/Utilities';
import { mutator } from 'satcheljs';
import {
    clearFocusTodoId,
    hideTodoContextMenu,
    setTodoListItemViewState,
    showTodoContextMenu,
    showCompletedTasks,
    hideCompletedTasks,
} from '../actions/todoFolderViewStateActions';

export const setTodoListItemViewStateMutator = mutator(setTodoListItemViewState, actionMessage => {
    const { itemId, viewState } = actionMessage;
    getSelectedFolderViewState().todoItemViewStates.set(itemId, viewState);
});

export const showTodoContextMenuMutator = mutator(showTodoContextMenu, actionMessage => {
    getSelectedFolderViewState().contextMenuViewState = {
        itemId: actionMessage.itemId,
        anchor: actionMessage.anchor,
    };
});

export const clearFocusTodoIdMutator = mutator(clearFocusTodoId, actionMessage => {
    getSelectedFolderViewState().focusTodoId = null;
});

export const hideTodoContextMenuMutator = mutator(hideTodoContextMenu, actionMessage => {
    getSelectedFolderViewState().contextMenuViewState = null;
});

export const showCompletedTasksMutator = mutator(showCompletedTasks, actionMessage => {
    getSelectedFolderViewState().showCompletedTasks = true;
});

export const hideCompletedTasksMutator = mutator(hideCompletedTasks, actionMessage => {
    getSelectedFolderViewState().showCompletedTasks = false;
});

export { TodoListItemViewState, IPoint };
